<template>
    <form @submit.prevent="candidateUUID ? requestUpdate() : requestCreate()">
        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                    <i class="mdi mdi-briefcase-outline mr-1"></i>
                    Application Details
                </h5>
                <div class="row">
                    <div class="col-md-7">
                        <b-form-group
                            label="Job Applied"
                            label-cols="3"
                            label-align="left"
                        >
                            <multiselect
                                v-model="createForm.candidate.candidateJob"
                                track-by="value"
                                label="text"
                                :placeholder="'Select'"
                                :select-label="'Select'"
                                :selected-label="'Selected'"
                                :deselect-label="'Select'"
                                :options="candidateJobDdl"
                                :searchable="true"
                                :allow-empty="false"
                                class="cursor-pointer"
                                :class="{ 'border border-danger': submitted && !$v.createForm.candidate.candidateJob.required }"
                            />
                            <div v-if="submitted && !$v.createForm.candidate.candidateJob.required" class="invalid-feedback d-block text-right">
                                {{ $t('message.requiredX', ['Job Applied']) }}
                            </div>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-md-5">
                        <b-form-group
                            label="Expected Salary"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.expectedSalary"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div> -->
                </div>
            </div>
        </div>

        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                    <i class="mdi mdi-account-outline mr-1"></i>
                    Section 1 — Personal Details
                </h5>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group
                            label="First Name"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.firstName"
                                :class="{ 'is-invalid': submitted && !$v.createForm.candidate.firstName.required }"
                                autocomplete="off"
                            />
                            <b-form-invalid-feedback v-if="submitted && !$v.createForm.candidate.firstName.required" class="text-right">
                                {{ $t('message.requiredX', ['First Name']) }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Last Name"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.lastName"
                                :class="{ 'is-invalid': submitted && !$v.createForm.candidate.lastName.required }"
                                autocomplete="off"
                            />
                            <b-form-invalid-feedback v-if="submitted && !$v.createForm.candidate.lastName.required" class="text-right">
                                {{ $t('message.requiredX', ['Last Name']) }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="English Name"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.englishName"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            label="Address"
                            label-cols="2"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.address1"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            label=""
                            label-cols="2"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.address2"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            label=""
                            label-cols="2"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.address3"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="City"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.city"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="State"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.state"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Postcode"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.postcode"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Country"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.country"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Phone"
                            label-cols="4"
                            label-align="left"
                        >
                            <vue-tel-input
                                v-on:country-changed="(country) => phoneCountryChanged(country)"
                                v-model.trim="createForm.candidate.phoneNumber"
                                :defaultCountry="createForm.candidate.phoneIso || 'MY'"
                                :autoDefaultCountry="false"
                                :autoFormat="false"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Home Phone"
                            label-cols="4"
                            label-align="left"
                        >
                            <vue-tel-input
                                v-on:country-changed="(country) => homePhoneCountryChanged(country)"
                                v-model.trim="createForm.candidate.homePhoneNumber"
                                :defaultCountry="createForm.candidate.homePhoneIso || 'MY'"
                                :autoDefaultCountry="false"
                                :autoFormat="false"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Email"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.email"
                                :class="{ 'is-invalid': submitted && $v.createForm.candidate.email.$error }"
                                autocomplete="off"
                            />
                            <b-form-invalid-feedback v-if="submitted && $v.createForm.candidate.email.$error" class="text-right">
                                <span v-if="!$v.createForm.candidate.email.required">{{ $t('message.requiredX', ['Email']) }}</span>
                                <span v-else-if="!$v.createForm.candidate.email.email">{{ $t('message.invalidX', ['Email']) }}</span>
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Birth Date"
                            label-cols="4"
                            label-align="left"
                        >
                            <DatePicker
                                v-model="createForm.candidate.birthDate"
                                placeholder="yyyy-mm-dd"
                                class="cursor-pointer"
                                :config="{
                                    format: 'YYYY-MM-DD',
                                    useCurrent: false,
                                    icons: {
                                        time: 'mdi mdi-clock-outline',
                                        date: 'mdi mdi-calendar',
                                        up: 'mdi mdi-chevron-up',
                                        down: 'mdi mdi-chevron-down',
                                        previous: 'mdi mdi-chevron-left',
                                        next: 'mdi mdi-chevron-right',
                                        today: 'mdi mdi-calendar-check',
                                        clear: 'mdi mdi-delete-outline',
                                        close: 'mdi mdi-close',
                                    },
                                }"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Birth Place"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.birthPlace"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Gender"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-select
                                v-model="createForm.candidate.gender"
                                :options="[{ value: 1, text: 'Male' }, { value: 0, text: 'Female' }]"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Race"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.race"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Ethnicity"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.ethnicity"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Religion"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.religion"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Nationality"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.nationality"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Marital Status"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-select
                                v-model="createForm.candidate.maritalStatus"
                                :options="maritalStatusDdl"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Malaysia ID"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.malaysiaId"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Passport"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-input
                                v-model.trim="createForm.candidate.passportNumber"
                                autocomplete="off"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Passport Expired"
                            label-cols="4"
                            label-align="left"
                        >
                            <DatePicker
                                v-model="createForm.candidate.passportExpiredDate"
                                placeholder="yyyy-mm-dd"
                                class="cursor-pointer"
                                :config="{
                                    format: 'YYYY-MM-DD',
                                    useCurrent: false,
                                    icons: {
                                        time: 'mdi mdi-clock-outline',
                                        date: 'mdi mdi-calendar',
                                        up: 'mdi mdi-chevron-up',
                                        down: 'mdi mdi-chevron-down',
                                        previous: 'mdi mdi-chevron-left',
                                        next: 'mdi mdi-chevron-right',
                                        today: 'mdi mdi-calendar-check',
                                        clear: 'mdi mdi-delete-outline',
                                        close: 'mdi mdi-close',
                                    },
                                }"
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group
                            label="If need, are you willing to work overtime?"
                            label-cols="12"
                            label-align="left"
                        >
                            <b-form-checkbox
                                v-model="createForm.candidate.willingOt"
                                switch
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group
                            label="Can we contact you at work?"
                            label-cols="12"
                            label-align="left"
                        >
                            <b-form-checkbox
                                v-model="createForm.candidate.callDuringWork"
                                switch
                            />
                        </b-form-group>
                    </div>
                    <div class="col-md-4">
                        <b-form-group
                            label="Are you willing to relocate?"
                            label-cols="12"
                            label-align="left"
                        >
                            <b-form-checkbox
                                v-model="createForm.candidate.willingToRelocate"
                                switch
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                    <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                        <i class="mdi mdi-briefcase-outline mr-1"></i>
                        Section 2 — Employment History
                    </h5>
                </div>
                <div
                    v-for="(item, index) in createForm.experiences"
                    :key="index"
                    class="border rounded p-3 mb-3 bg-white"
                >
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="font-weight-bold mb-0">Employment {{ index + 1 }}</h6>
                        <b-button
                            variant="outline-danger"
                            size="sm"
                            @click="createForm.experiences.splice(index, 1)"
                        >
                            <i class="mdi mdi-close"></i>
                        </b-button>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-group label="Name of Employer">
                                <b-form-input
                                    v-model.trim="item.company"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Position Held">
                                <b-form-input
                                    v-model.trim="item.name"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <b-form-group label="Address">
                                <b-form-textarea
                                    v-model.trim="item.address"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Department">
                                <b-form-input
                                    v-model.trim="item.department"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Location">
                                <b-form-input
                                    v-model.trim="item.location"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Salary">
                                <b-form-input
                                    v-model.trim="item.salary"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Start Date">
                                <DatePicker
                                    v-model="item.startDate"
                                    placeholder="yyyy-mm-dd"
                                    class="cursor-pointer"
                                    :config="{
                                        format: 'YYYY-MM-DD',
                                        useCurrent: false,
                                        icons: {
                                            time: 'mdi mdi-clock-outline',
                                            date: 'mdi mdi-calendar',
                                            up: 'mdi mdi-chevron-up',
                                            down: 'mdi mdi-chevron-down',
                                            previous: 'mdi mdi-chevron-left',
                                            next: 'mdi mdi-chevron-right',
                                            today: 'mdi mdi-calendar-check',
                                            clear: 'mdi mdi-delete-outline',
                                            close: 'mdi mdi-close',
                                        },
                                    }"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="End Date">
                                <DatePicker
                                    v-model="item.endDate"
                                    placeholder="yyyy-mm-dd"
                                    class="cursor-pointer"
                                    :config="{
                                        format: 'YYYY-MM-DD',
                                        useCurrent: false,
                                        icons: {
                                            time: 'mdi mdi-clock-outline',
                                            date: 'mdi mdi-calendar',
                                            up: 'mdi mdi-chevron-up',
                                            down: 'mdi mdi-chevron-down',
                                            previous: 'mdi mdi-chevron-left',
                                            next: 'mdi mdi-chevron-right',
                                            today: 'mdi mdi-calendar-check',
                                            clear: 'mdi mdi-delete-outline',
                                            close: 'mdi mdi-close',
                                        },
                                    }"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Current">
                                <b-form-checkbox
                                    v-model="item.isCurrent"
                                    switch
                                    class="mt-2"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Years of Service">
                                <b-form-input
                                    v-model.trim="item.yearsOfService"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Notice Month">
                                <b-form-input
                                    v-model.trim="item.periodNoticeMonth"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Reason For Leaving">
                                <b-form-textarea
                                    v-model.trim="item.reasonForLeaving"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group label="Service Summary">
                                <b-form-textarea
                                    v-model.trim="item.serviceSummary"
                                />
                            </b-form-group>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <b-button
                        variant="info"
                        size="sm"
                        @click="createForm.experiences.push(defaultExperience())"
                    >
                        <i class="mdi mdi-plus"></i>
                    </b-button>
                </div>
            </div>
        </div>

        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                    <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                        <i class="mdi mdi-school-outline mr-1"></i>
                        Section 3 — Education
                    </h5>
                </div>
                <div
                    v-for="(item, index) in createForm.educations"
                    :key="index"
                    class="border rounded p-3 mb-3 bg-white"
                >
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="font-weight-bold mb-0">Education {{ index + 1 }}</h6>
                        <b-button
                            variant="outline-danger"
                            size="sm"
                            @click="createForm.educations.splice(index, 1)"
                        >
                            <i class="mdi mdi-close"></i>
                        </b-button>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group label="Qualification">
                                <b-form-input
                                    v-model.trim="item.name"
                                    placeholder="e.g. SPM, Diploma, Bachelor's Degree"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Field">
                                <b-form-input
                                    v-model.trim="item.field"
                                    placeholder="e.g. Accounting, Engineering, Science"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-2">
                            <b-form-group label="Start Date">
                                <DatePicker
                                    v-model="item.startDate"
                                    placeholder="yyyy-mm-dd"
                                    class="cursor-pointer"
                                    :config="{
                                        format: 'YYYY-MM-DD',
                                        useCurrent: false,
                                        icons: {
                                            time: 'mdi mdi-clock-outline',
                                            date: 'mdi mdi-calendar',
                                            up: 'mdi mdi-chevron-up',
                                            down: 'mdi mdi-chevron-down',
                                            previous: 'mdi mdi-chevron-left',
                                            next: 'mdi mdi-chevron-right',
                                            today: 'mdi mdi-calendar-check',
                                            clear: 'mdi mdi-delete-outline',
                                            close: 'mdi mdi-close',
                                        },
                                    }"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-2">
                            <b-form-group label="End Date">
                                <DatePicker
                                    v-model="item.endDate"
                                    placeholder="yyyy-mm-dd"
                                    class="cursor-pointer"
                                    :config="{
                                        format: 'YYYY-MM-DD',
                                        useCurrent: false,
                                        icons: {
                                            time: 'mdi mdi-clock-outline',
                                            date: 'mdi mdi-calendar',
                                            up: 'mdi mdi-chevron-up',
                                            down: 'mdi mdi-chevron-down',
                                            previous: 'mdi mdi-chevron-left',
                                            next: 'mdi mdi-chevron-right',
                                            today: 'mdi mdi-calendar-check',
                                            clear: 'mdi mdi-delete-outline',
                                            close: 'mdi mdi-close',
                                        },
                                    }"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="School / College / University">
                                <b-form-input
                                    v-model.trim="item.institute"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Location">
                                <b-form-input
                                    v-model.trim="item.location"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Grade">
                                <b-form-input
                                    v-model.trim="item.grade"
                                    placeholder="e.g. 5A3B, CGPA 3.50"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <b-form-group label="Description">
                                <b-form-textarea
                                    v-model.trim="item.description"
                                />
                            </b-form-group>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <b-button
                        variant="info"
                        size="sm"
                        @click="createForm.educations.push(defaultEducation())"
                    >
                        <i class="mdi mdi-plus"></i>
                    </b-button>
                </div>
            </div>
        </div>

        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                    <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                        <i class="mdi mdi-account-group-outline mr-1"></i>
                        Section 4 — Family Background
                    </h5>
                </div>
                <div
                    v-for="(item, index) in createForm.families"
                    :key="index"
                    class="border rounded p-3 mb-3 bg-white"
                >
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="font-weight-bold mb-0">Family {{ index + 1 }}</h6>
                        <b-button
                            variant="outline-danger"
                            size="sm"
                            @click="createForm.families.splice(index, 1)"
                        >
                            <i class="mdi mdi-close"></i>
                        </b-button>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group label="Name">
                                <b-form-input
                                    v-model.trim="item.name"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Relationship">
                                <b-form-input
                                    v-model.trim="item.relationship"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Occupation">
                                <b-form-input
                                    v-model.trim="item.occupation"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <b-form-group label="Address">
                                <b-form-textarea
                                    v-model.trim="item.address"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-8">
                            <b-form-group label="Phone">
                                <vue-tel-input
                                    v-on:country-changed="(country) => familyPhoneCountryChanged(country, item)"
                                    v-model.trim="item.phoneNumber"
                                    :defaultCountry="item.phoneIso || 'MY'"
                                    :autoDefaultCountry="false"
                                    :autoFormat="false"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                            <b-form-group label="Emergency Contact">
                                <b-form-checkbox
                                    v-model="item.isEmergency"
                                    switch
                                    class="mt-2"
                                />
                            </b-form-group>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <b-button
                        variant="info"
                        size="sm"
                        @click="createForm.families.push(defaultFamily())"
                    >
                        <i class="mdi mdi-plus"></i>
                    </b-button>
                </div>
            </div>
        </div>
        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <div class="d-flex justify-content-between align-items-center mb-3 px-3 py-2" style="background-color: #60d1f2;">
                    <h5 class="font-weight-bold mb-0" style="color: #172b3a;">
                        <i class="mdi mdi-translate mr-1"></i>
                        Section 5 — Languages
                    </h5>
                </div>
                <div
                    v-for="(item, index) in createForm.languages"
                    :key="index"
                    class="border rounded p-3 mb-3 bg-white"
                >
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="font-weight-bold mb-0">Language {{ index + 1 }}</h6>
                        <b-button
                            variant="outline-danger"
                            size="sm"
                            @click="createForm.languages.splice(index, 1)"
                        >
                            <i class="mdi mdi-close"></i>
                        </b-button>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group label="Language">
                                <b-form-input
                                    v-model.trim="item.name"
                                    autocomplete="off"
                                />
                            </b-form-group>
                        </div>
                        <div class="col-md-2">
                            <b-form-group label="Write">
                                <div class="d-flex align-items-center">
                                    <b-form-input
                                        v-model.trim="item.write"
                                        type="range"
                                        min="1"
                                        max="5"
                                        autocomplete="off"
                                    />
                                    <span class="ml-2">{{ item.write }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-md-2">
                            <b-form-group label="Read">
                                <div class="d-flex align-items-center">
                                    <b-form-input
                                        v-model.trim="item.read"
                                        type="range"
                                        min="1"
                                        max="5"
                                        autocomplete="off"
                                    />
                                    <span class="ml-2">{{ item.read }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-md-2">
                            <b-form-group label="Spoken">
                                <div class="d-flex align-items-center">
                                    <b-form-input
                                        v-model.trim="item.spoken"
                                        type="range"
                                        min="1"
                                        max="5"
                                        autocomplete="off"
                                    />
                                    <span class="ml-2">{{ item.spoken }}</span>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="col-md-2">
                            <b-form-group label="Listen">
                                <div class="d-flex align-items-center">
                                    <b-form-input
                                        v-model.trim="item.listen"
                                        type="range"
                                        min="1"
                                        max="5"
                                        autocomplete="off"
                                    />
                                    <span class="ml-2">{{ item.listen }}</span>
                                </div>
                            </b-form-group>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <b-button
                        variant="info"
                        size="sm"
                        @click="createForm.languages.push(defaultLanguage())"
                    >
                        <i class="mdi mdi-plus"></i>
                    </b-button>
                </div>
            </div>
        </div>
        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                    <i class="mdi mdi-medical-bag mr-1"></i>
                    Section 6 — Health
                </h5>
                <div class="row">
                    <div class="col-md-12">
                        <div class="row align-items-center mb-2">
                            <div class="col-md-4">
                                Blood Type
                            </div>
                            <div class="col-md-8">
                                <b-form-input
                                    v-model.trim="createForm.medical.bloodType"
                                    autocomplete="off"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row align-items-center mb-2">
                            <div class="col-md-4">
                                <b-form-checkbox
                                    v-model="createForm.medical.physicalImpairmentDisease"
                                    @change="createForm.medical.physicalImpairmentDiseaseRemark = $event ? createForm.medical.physicalImpairmentDiseaseRemark : ''"
                                    switch
                                >
                                    Physical Impairment / Disease
                                </b-form-checkbox>
                            </div>
                            <div class="col-md-8">
                                <b-form-input
                                    v-model.trim="createForm.medical.physicalImpairmentDiseaseRemark"
                                    placeholder="Remark"
                                    autocomplete="off"
                                    :class="[createForm.medical.physicalImpairmentDisease ? 'fade-in' : 'bg-light']"
                                    :disabled="!createForm.medical.physicalImpairmentDisease"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row align-items-center mb-2">
                            <div class="col-md-4">
                                <b-form-checkbox
                                    v-model="createForm.medical.seriousIllness"
                                    @change="createForm.medical.seriousIllnessRemark = $event ? createForm.medical.seriousIllnessRemark : ''"
                                    switch
                                >
                                    Serious Illness
                                </b-form-checkbox>
                            </div>
                            <div class="col-md-8">
                                <b-form-input
                                    v-model.trim="createForm.medical.seriousIllnessRemark"
                                    placeholder="Remark"
                                    autocomplete="off"
                                    :class="[createForm.medical.seriousIllness ? 'fade-in' : 'bg-light']"
                                    :disabled="!createForm.medical.seriousIllness"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row align-items-center mb-2">
                            <div class="col-md-4">
                                <b-form-checkbox
                                    v-model="createForm.medical.medicationAllergy"
                                    @change="createForm.medical.medicationAllergyRemark = $event ? createForm.medical.medicationAllergyRemark : ''"
                                    switch
                                >
                                    Medication Allergy
                                </b-form-checkbox>
                            </div>
                            <div class="col-md-8">
                                <b-form-input
                                    v-model.trim="createForm.medical.medicationAllergyRemark"
                                    placeholder="Remark"
                                    autocomplete="off"
                                    :class="[createForm.medical.medicationAllergy ? 'fade-in' : 'bg-light']"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="row align-items-center">
                            <div class="col-md-4">
                                <b-form-checkbox
                                    v-model="createForm.medical.isPregnant"
                                    switch
                                >
                                    Pregnant
                                </b-form-checkbox>
                            </div>
                            <div class="col-md-8">
                                <b-form-input
                                    v-model.trim="createForm.medical.pregnantMonth"
                                    placeholder="Month"
                                    autocomplete="off"
                                    :class="[createForm.medical.isPregnant ? 'fade-in': 'bg-light']"
                                    :disabled="!createForm.medical.isPregnant"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card border mb-3">
            <div class="card-body px-4 py-4">
                <h5 class="font-weight-bold mb-3 px-3 py-2" style="background-color: #60d1f2; color: #172b3a;">
                    <i class="mdi mdi-file-document-outline mr-1"></i>
                    Section 7 — Supporting Documents & Work Preferences
                </h5>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group
                            label="Photo"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-file v-model="createForm.candidate.photo" />
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            label="Resume"
                            label-cols="4"
                            label-align="left"
                        >
                            <b-form-file v-model="createForm.candidate.resume" />
                        </b-form-group>
                    </div>
                </div>
            </div>
        </div>
        <b-form-group
            label="Application Completed"
            label-cols="3"
            label-align="left"
        >
            <b-form-checkbox
                v-model="createForm.candidate.isApplicationCompleted"
                switch
                class="mt-2"
            />
        </b-form-group>
        <div class="d-flex justify-content-end mb-4">
            <b-button
                type="button"
                variant="danger"
                class="mr-2 col-md-2"
                @click="$emit('close')"
            >
                {{ $t('label.cancel') }}
            </b-button>
            <b-button
                type="submit"
                variant="info"
                class="col-md-2"
                :disabled="!status.save"
            >
                <span v-if="status.save">
                    {{ candidateUUID ? $t('label.updateX', []) : $t('label.createX', []) }}
                </span>
                <b-spinner v-else small />
            </b-button>
        </div>
    </form>
</template>
<script>
import { MARITAL_STATUS } from "@/constants/marital";
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import Multiselect from "vue-multiselect";
import { VueTelInput } from 'vue-tel-input';
import { required, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { candidateMethods, lookupMethods } from "@/state/api";
import { CANDIDATE_MODULE } from "@/state/api/candidate.state";

export default {
    components: { DatePicker, Multiselect, VueTelInput },
    props: {
        candidateUUID: {
            type: String,
            required: false,
        },
        candidateStatusUUID: {
            type: String,
            required: false,
        },
        searchCriteria: {
            type: Object,
            required: false,
        },
    },
    validations() {
        return {
            createForm: {
                candidate: {
                    candidateJob: { required },
                    firstName: { required },
                    lastName: { required },
                    email: { required, email },
                },
            },
        };
    },
    async created() {
        await this.lookupCandidateJob();
        await this.getCandidateData();
    },
    data() {
        return {
            submitted: false,
            maritalStatusDdl: MARITAL_STATUS,
            createForm: this.defaultForm(),
        };
    },
    methods: {
        ...candidateMethods,
        ...lookupMethods,
        defaultForm() {
            return {
                uuid: null,
                candidate: {
                    candidateJob: null,
                    candidateJobUuid: null,
                    candidateStatusUuid: this.candidateStatusUUID,
                    firstName: "",
                    lastName: "",
                    englishName: "",
                    phoneCode: "",
                    phoneIso: "",
                    phoneNumber: "",
                    homePhoneIso: "",
                    homePhoneCode: "",
                    homePhoneNumber: "",
                    email: "",
                    companyEmail: "",
                    birthDate: "",
                    birthPlace: "",
                    gender: null,
                    malaysiaId: "",
                    passportNumber: "",
                    passportExpiredDate: "",
                    maritalStatus: null,
                    nationality: "",
                    race: "",
                    ethnicity: "",
                    religion: "",
                    expectedSalary: "",
                    address1: "",
                    address2: "",
                    address3: "",
                    city: "",
                    state: "",
                    postcode: "",
                    country: "",
                    callDuringWork: false,
                    willingOt: false,
                    willingToRelocate: false,
                    isApplicationCompleted: false,
                    photo: null,
                    resume: null,
                },
                languages: [this.defaultLanguage()],
                educations: [this.defaultEducation()],
                experiences: [this.defaultExperience()],
                families: [this.defaultFamily()],
                medical: this.defaultMedical(),
            };
        },
        defaultLanguage() {
            return {
                name: "",
                write: 1,
                read: 1,
                spoken: 1,
                listen: 1,
            };
        },
        defaultEducation() {
            return { 
                name: "", 
                field: "", 
                institute: "", 
                location: "", 
                grade: "", 
                startDate: "", 
                endDate: "", 
                description: "",
            };
        },
        defaultExperience() {
            return { 
                name: "", 
                company: "", 
                location: "", 
                startDate: "", 
                endDate: "", 
                department: "", 
                salary: "", 
                periodNoticeMonth: "",
                reasonForLeaving: "",
                isCurrent: false,
                serviceSummary: "",
                address: "",
                yearsOfService: "",
            };
        },
        defaultFamily() {
            return {
                name: "",
                relationship: "",
                occupation: "",
                address: "",
                phoneNumber: "",
                phoneCode: "",
                phoneIso: "",
                isEmergency: false,
            };
        },
        defaultMedical() {
            return {
                physicalImpairmentDisease: false,
                physicalImpairmentDiseaseRemark: "",
                seriousIllness: false,
                seriousIllnessRemark: "",
                medicationAllergy: false,
                medicationAllergyRemark: "",
                bloodType: "",
                isPregnant: false,
                pregnantMonth: "",
            };
        },
        phoneCountryChanged(country) {
            this.createForm.candidate.phoneCode = "+" + country.dialCode;
            this.createForm.candidate.phoneIso = country.iso2;
        },
        homePhoneCountryChanged(country) {
            this.createForm.candidate.homePhoneCode = "+" + country.dialCode;
            this.createForm.candidate.homePhoneIso = country.iso2;
        },
        familyPhoneCountryChanged(country, item) {
            item.phoneCode = "+" + country.dialCode;
            item.phoneIso = country.iso2;
        },
        async getCandidateData() {
            if (this.candidateUUID) {
                await this.getCandidate({ uuid: this.candidateUUID })
                    .then((result) => {
                        const data = JSON.parse(JSON.stringify(this.data));
                        if (result?.success) {
                            this.createForm = {
                                ...data,
                                uuid: data.uuid,
                                candidate: {
                                    ...data,
                                    phoneNumber: String(data.phoneNumber ?? ""),
                                    homePhoneNumber: String(data.homePhoneNumber ?? ""),
                                    candidateJob: data.candidateJob ? {
                                        value: data.candidateJob.uuid,
                                        text: data.candidateJob.name,
                                    } : null,
                                    candidateJobUuid: data.candidateJob?.uuid,
                                    candidateStatusUuid: data.candidateStatus?.uuid || this.candidateStatusUUID,
                                    isApplicationCompleted: data.isApplicationCompleted ? true : false,
                                    photo: null,
                                    resume: null,
                                },
                                languages: data.candidateLanguages.length ? [...data.candidateLanguages] : [this.defaultLanguage()],
                                educations: data.candidateEducations.length ? [...data.candidateEducations] : [this.defaultEducation()],
                                experiences: data.candidateExperiences.length ? [...data.candidateExperiences] : [this.defaultExperience()],
                                families: data.candidateFamilies.length ? data.candidateFamilies.map(item => ({
                                    ...item,
                                    phoneNumber: String(item.phoneNumber ?? ""),
                                })) : [this.defaultFamily()],
                                medical: data.candidateMedical || this.defaultMedical(),
                            };
                        }
                    });
            }
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    candidate: {
                        ...this.createForm.candidate,
                        candidateJobUuid: this.createForm.candidate.candidateJob?.value,
                        callDuringWork: this.createForm.candidate.callDuringWork ? 1 : 0,
                        willingOt: this.createForm.candidate.willingOt ? 1 : 0,
                        willingToRelocate: this.createForm.candidate.willingToRelocate ? 1 : 0,
                        isApplicationCompleted: this.createForm.candidate.isApplicationCompleted ? 1 : 0,
                    },
                    educations: this.createForm.educations
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    languages: this.createForm.languages
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    experiences: this.createForm.experiences
                        .filter(item => item.company)
                        .map(item => ({
                            ...item,
                            isCurrent: item.isCurrent ? 1 : 0,
                        })),
                    families: this.createForm.families
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                            isEmergency: item.isEmergency ? 1 : 0,
                        })),
                    medical: {
                        ...this.createForm.medical,
                        physicalImpairmentDisease: this.createForm.medical.physicalImpairmentDisease ? 1 : 0,
                        seriousIllness: this.createForm.medical.seriousIllness ? 1 : 0,
                        medicationAllergy: this.createForm.medical.medicationAllergy ? 1 : 0,
                        isPregnant: this.createForm.medical.isPregnant ? 1 : 0,
                    },
                };
                this.createCandidate({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit('done');
                        }
                    }));
            }
        },
        requestUpdate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                let data = {
                    ...this.createForm,
                    candidate: {
                        ...this.createForm.candidate,
                        candidateJobUuid: this.createForm.candidate.candidateJob?.value,
                        callDuringWork: this.createForm.candidate.callDuringWork ? 1 : 0,
                        willingOt: this.createForm.candidate.willingOt ? 1 : 0,
                        willingToRelocate: this.createForm.candidate.willingToRelocate ? 1 : 0,
                        isApplicationCompleted: this.createForm.candidate.isApplicationCompleted ? 1 : 0,
                    },
                    educations: this.createForm.educations
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    languages: this.createForm.languages
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                        })),
                    experiences: this.createForm.experiences
                        .filter(item => item.company)
                        .map(item => ({
                            ...item,
                            isCurrent: item.isCurrent ? 1 : 0,
                        })),
                    families: this.createForm.families
                        .filter(item => item.name)
                        .map(item => ({
                            ...item,
                            isEmergency: item.isEmergency ? 1 : 0,
                        })),
                    medical: {
                        ...this.createForm.medical,
                        physicalImpairmentDisease: this.createForm.medical.physicalImpairmentDisease ? 1 : 0,
                        seriousIllness: this.createForm.medical.seriousIllness ? 1 : 0,
                        medicationAllergy: this.createForm.medical.medicationAllergy ? 1 : 0,
                        isPregnant: this.createForm.medical.isPregnant ? 1 : 0,
                    },
                };
                this.updateCandidate({data, filter: this.searchCriteria})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success) {
                            this.resetForm();
                            this.$emit('done');
                        }
                    }));
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
    computed: {
        ...mapState(CANDIDATE_MODULE, ['status']),
        data() {
            const data = this.$store.state.api.candidate.details;
            return data;
        },
        candidateJobDdl() {
            return this.$store.state.api.lookup.candidateJobDdl || [];
        },
    },
}
</script>
